export enum TableSelectionMode {
  Single = 'single',
  Multiple = 'multiple',
}
